import { ModelTreeFilter } from "./types";

export const emptyFileTypeFilters: ModelTreeFilter[] = [];
